import axios from 'axios'

/**
 * Default Axios configuration
 * @type {AxiosInstance}
 */
const HTTP = axios.create({
  baseURL: process.env.BACK_API_URL,
  // `onUploadProgress` allows handling of progress events for uploads
  onUploadProgress: function (progressEvent) {
    //@todo voir si on met autre chose
    // NProgress.set(0.5);
  },
  // `onDownloadProgress` allows handling of progress events for downloads
  onDownloadProgress: function (progressEvent) {
    //@todo voir si on met autre chose
    //NProgress.set(0.8);
  },
})

export default HTTP



// WEBPACK FOOTER //
// ./src/axiosConnection.js